import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Autocomplete } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCustomers } from '../../../redux/Slice/customerSlice';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { fetchProductTemplates } from '../../../redux/Slice/ProductTemplate';
import { addProduct, confirmProduct } from '../../../redux/Slice/Product';
import { Editor } from '@monaco-editor/react';
import { setLoading } from '../../../redux/Slice/loaderSlice';

const AddProduct = () => {
    const dispatch = useDispatch();
    const { customers } = useSelector((state) => state.customer); // Assume customers list is in the Redux store
    const { Producttemplates } = useSelector((state) => state.productTemplate); // Assume customers list is in the Redux store
    const [response, setResponse] = useState(null);
    const defaultOption = { companyName: 'Default', _id: 0 };
    const [formData, setFormData] = useState({
        customer: null ,
        template: null,
        data: '',
    });

    useEffect(() => {
      // Dispatch an action to fetch the customer list
      dispatch(fetchCustomers());
      dispatch(fetchProductTemplates());
    }, [dispatch]);

    const handleChange = (field) => (event, value) => {
        console.log(event.target.value);
        setFormData((prev) => ({
            ...prev,
            [field]: value ? value.id || value._id : null, // Use id/_id depending on the field
        }));
        console.log(formData) 
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log('Form Data:', formData);
        dispatch(setLoading(true));        
        // Dispatch an action to handle form submission
        dispatch(addProduct(formData)).then((res) => {
            console.log(res.payload.data.data);
            setResponse(JSON.stringify(res.payload.data.data,null,2))
            dispatch(setLoading(false));
        })
    };  
    const handleConfrimSubmit = (event) => {
      event.preventDefault();
         dispatch(setLoading(true));
        const formData = {
          data: response,
        };
        // Dispatch an action to handle form submission
        dispatch(confirmProduct(formData)).then((res) => {
          console.log(res);
            dispatch(setLoading(false));
        });
    };  
  
    return (
      <Box
        sx={{
          display: "flex",
          width: "100%",
        }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: 2,
            pr: 4,
            width: "70%",
            height: "100%",
          }}>
          <Typography variant="h4" gutterBottom>
            Add Product
          </Typography>

          <Autocomplete
            style={{
              position: "fixed",
              top: "65px",
              right: "100px",
              width: "200px",
            }}
            options={[...customers, defaultOption]}
            variant="standard"
            getOptionLabel={(option) => option.companyName}
            value={[...customers, defaultOption].find(
              (c) => c.id === formData.customer
            )} // Find selected option by id
            onChange={handleChange("customer")}
            renderInput={(params) => (
              <TextField {...params} label="Customer" required />
            )}
            filterOptions={(options, state) => {
              const filtered = options.filter((option) =>
                option.companyName && option.companyName
                  .toLowerCase()
                  .includes(state.inputValue.toLowerCase())
              );
              // If no matches, include the default option
              if (filtered.length === 0 && state.inputValue.trim() !== "") {
                return [defaultOption];
              }
              return filtered;
            }}
          />
          <Autocomplete
            options={Producttemplates}
            variant="outlined"
            getOptionLabel={(option) => option.templateName}
            value={
              Producttemplates.find((t) => t._id === formData.template) || null
            } // Find selected template by _id
            onChange={handleChange("template")}
            renderInput={(params) => (
              <TextField {...params} label="Template" required />
            )}
          />
          <TextareaAutosize
            type="textarea"
            label="Description"
            value={formData.data}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                data: e.target.value, // Use id/_id depending on the field
              }))
            }
            style={{ height: "650px", maxHeight: "600px" }}
            rows={4}
          />
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
        <Box
          component="form"
          onSubmit={handleConfrimSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}>
          <Editor
            language="text"
            value={response}
            style={{ maxHeight: "400px", height: "400px" }}
            height={"700px"}
          />
          <Button type="submit">submit</Button>
        </Box>
      </Box>
    );
};

export default AddProduct;
